import {
  MIDI_DEAL_PRODUCTS_REQUEST,
  MIDI_DEAL_PRODUCTS_SUCCESS,
  MIDI_DEAL_PRODUCTS_FAIL,
  MIDI_DEAL_EVENT_REQUEST,
  MIDI_DEAL_EVENT_SUCCESS,
  MIDI_DEAL_EVENT_FAIL,
  MIDI_DEAL_ELIGIBILITY_REQUEST,
  MIDI_DEAL_ELIGIBILITY_SUCCESS,
  MIDI_DEAL_ELIGIBILITY_FAIL,
  MIDI_DEAL_STATUS_REQUEST,
  MIDI_DEAL_STATUS_SUCCESS,
  MIDI_DEAL_STATUS_FAIL,
} from '../constants/midiDealConstants';

const FIVE_MINUTES = 5 * 60 * 1000;
const CACHE_DURATION_MS = FIVE_MINUTES;


export const getMidiDealProducts =
  (storeId, axiosInstance) => async (dispatch, getState) => {
    const { midiDeal } = getState();

    if (midiDeal.loading) return;

    if (
      midiDeal.products &&
      midiDeal.lastFetchedAt &&
      midiDeal.lastStoreId === storeId &&
      Date.now() - midiDeal.lastFetchedAt < CACHE_DURATION_MS
    ) {
      return;
    }

    dispatch({ type: MIDI_DEAL_PRODUCTS_REQUEST });

    try {
      const { data } = await axiosInstance.get(
        '/midi-deal/products',
        { params: { storeId } }
      );

      dispatch({ type: MIDI_DEAL_PRODUCTS_SUCCESS, payload: data, storeId });
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      console.error('Error fetching MIDI deal products:', error);
      dispatch({ type: MIDI_DEAL_PRODUCTS_FAIL, payload: message });
    }
  };


export const logMidiDealEvent = (axiosInstance, eventData) => async (dispatch) => {
  dispatch({ type: MIDI_DEAL_EVENT_REQUEST });

  try {
    const { data } = await axiosInstance.post('/midi-deal/event', eventData);
    dispatch({ type: MIDI_DEAL_EVENT_SUCCESS, payload: data });
  } catch (error) {
    const message = error?.response?.data?.message || error.message;
    console.error('Error logging Midi deal event:', error);
    dispatch({ type: MIDI_DEAL_EVENT_FAIL, payload: message });
  }
};
export const getMidiDealStatus =
  (storeId, axiosInstance) => async (dispatch) => {
    dispatch({ type: MIDI_DEAL_STATUS_REQUEST });

    try {
      const { data } = await axiosInstance.get('/midi-deal/status', {
        params: { storeId },
      });

      dispatch({ type: MIDI_DEAL_STATUS_SUCCESS, payload: data });
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      console.error('Error fetching MIDI deal status:', error);
      dispatch({ type: MIDI_DEAL_STATUS_FAIL, payload: message });
    }
  };

export const checkMidiDealEligibility =
  (barcode, storeId, axiosInstance) => async (dispatch) => {
    dispatch({ type: MIDI_DEAL_ELIGIBILITY_REQUEST });

    try {
      const { data } = await axiosInstance.get(
        '/midi-deal/eligibility',
        { params: { barcode, storeId } }
      );

      dispatch({ type: MIDI_DEAL_ELIGIBILITY_SUCCESS, payload: data });
    } catch (error) {
      console.error('Error checking MIDI deal eligibility:', error);
      dispatch({
        type: MIDI_DEAL_ELIGIBILITY_FAIL,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };
